import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import HomePage from './vistas/HomePage';
import Formulario from './vistas/Formulario';
import FormCompra from './vistas/FormCompra';
import CompletedForm from './vistas/CompletedForm';
import AdminDashboard from './vistas/AdminDashboard';

// Componente para manejar rutas y animación en cambios de página
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomePage />} />
        <Route path="/deltagarage" element={<HomePage />} />
        <Route path="/form" element={<Formulario />} />
        <Route path="/compra" element={<FormCompra />} />
        <Route path="/fin" element={<CompletedForm />} />
        <Route path="/admin" element={<AdminDashboard />} />  {/* Nueva ruta para el login y tabla */}
      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  return (
    <Router basename="/deltagarage" >
      <AnimatedRoutes />
    </Router>
  );
};

export default App;
